module.exports = __webpack_public_path__ + "img/properties.5ca36989.svg";